import lottie from 'lottie-web';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// import сustomPageScroll from '../components/_custom-scroll';

// import initScrollTrigger from '../helpers/_initScrollTrigger';
// import getLottiePath from '../helpers/getLottiePath';

gsap.registerPlugin(ScrollTrigger);

const START_PATH = document.body.getAttribute('data-lottie-path');

export const getLottiePath = (el) => {
	const path = el.getAttribute('data-name');
	return `${START_PATH}/${path}.json`;
};

export const getNewLottieAnim = (el, params = {}) => {
	return lottie.loadAnimation({
		container: el,
		renderer: 'svg',
		loop: false,
		autoplay: false,
		speed: 1,
		path: getLottiePath(el),
		...params,
	});
};

export const initScrollLottie = (el, params = {}, callback = () => {}) => {
	const anim = getNewLottieAnim(el, params);

	anim.addEventListener('DOMLoaded', () => {
		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if(entry.isIntersecting) {
					anim.play();
				}
				else {
					anim.pause();
				}
			});
		}, { threshold: 0 });
		observer.observe(el);
		callback();
	});
};

// export const initScrollLottie = (el) => {
// 	const anim = getNewLottieAnim(el);
// 	anim.addEventListener('DOMLoaded', () => {
// 		ScrollTrigger.create({
// 			trigger: el,
// 			start: 'top 78%',
// 			end: '+=100%',
// 			onEnter: () => anim.play(),
// 			onLeaveBack: self => self.disable()
// 		});
// 	});
// };


// export const initAllScrollLottie = () => {
// 	initScrollTrigger();

// 	const elems = document.querySelectorAll('.js-scroll-lottie');
// 	elems.forEach(el => initScrollLottie(el));


// export const

